/* global JWPLAYER_LICENSE_KEY */
import React, { useState } from 'react'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { walkthroughDispatchers as dispatchers } from 'reduxModules/users/dispatchers'

import JWPlayer from '@jwplayer/jwplayer-react'

import './styles.css'

function WalkthroughVideo(props) {
  const [player, setPlayer] = useState(null)
  const onReadyCallback = (status) => {
    if (status?.type === 'ready')
      player.on('play', () => props.updateWatchedWalkthrough())
  }
  const didMountCallback = ({ player }) => {
    setPlayer(player)
  }

  return (
    <article className="wrapper" id="WalkthroughVideo">
      <section className="heading">
        <h1>Walkthrough</h1>
      </section>
      <section className="walkthrough-video">
        <div className="player-container">
          <JWPlayer
            library="../../global/vendor/jwplayer-8.48.1/jwplayer.js"
            config={{
              key: JWPLAYER_LICENSE_KEY,
              width: '100%',
              height: '100%',
              autostart: true
            }}
            didMountCallback={didMountCallback}
            onReady={onReadyCallback}
            playlist={{
              sources: [
                {
                  file: 'https://d35pwikzwzmbep.cloudfront.net/videos/about/2025-04-EXPLAINER-VID-audio-edit2-active-subs-Hi.mp4'
                }
              ],
              tracks: [
                {
                  file: 'https://d35pwikzwzmbep.cloudfront.net/videos/about/2025-04-EXPLAINER-VID-audio-edit2-active-subs-en.vtt',
                  kind: 'captions',
                  label: 'English'
                },
                {
                  file: 'https://d35pwikzwzmbep.cloudfront.net/videos/about/2025-04-EXPLAINER-VID-audio-edit2-active-subs-es.vtt',
                  kind: 'captions',
                  label: 'Spanish'
                },
                {
                  file: 'https://d35pwikzwzmbep.cloudfront.net/videos/about/2025-04-EXPLAINER-VID-audio-edit2-active-subs-chapters.vtt',
                  kind: 'chapters'
                }
              ]
            }}
          />
        </div>
        <p className="walkthrough-video__description">
          <b>Everything you need to know, all in one short video.</b> This quick
          walkthrough shows you how to navigate your account, find and watch
          courses, follow skill-building Learning Pathways, bookmark lessons,
          access materials lists, explore exclusive behind-the-scenes content,
          join the community forums, and get support anytime.
        </p>
        <div className="start-learning-container">
          <Link to="/tutorials" className="btn -orange">
            Start Learning
          </Link>
        </div>
      </section>
    </article>
  )
}

export default connect(null, dispatchers)(WalkthroughVideo)
